import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class SymbolDataDownloadLogService {

  constructor(private httpClient: HttpClient) {
  }

  getSymbolDataDownloadLogList(page: number, user, company, type, downloadedData, dateFrom, dateTo, sortField, sortOrder): Observable<any> {
    let url = environment.baseUrlWs + `/api/get-symbol-data-log-list?page=${page}`;
    if (user) {
      url += '&user=' + encodeURIComponent(user);
    }
    if (company) {
      url += '&company=' + company;
    }
    if (type) {
      url += '&type=' + type;
    }
    if (downloadedData) {
      url += '&downloadedData=' + downloadedData;
    }
    if (dateFrom) {
      url += '&dateFrom=' + dateFrom;
    }
    if (dateTo) {
      url += '&dateTo=' + dateTo;
    }
    if (sortField) {
      url += '&sortField=' + sortField;
    }
    if (sortOrder) {
      url += '&sortOrder=' + sortOrder;
    }
    return this.httpClient.get<any>(url);
  }

  getSymbolDataDownloadLogListFilters(): Observable<any> {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/get-symbol-data-log-list-filters');
  }
}
